module.exports = __webpack_public_path__ + "media/daily-vlog.264bad8f.mp4";